import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../setup/auth/authService';

const LogoutPage = () => {
    const { t } = useTranslation();
    const { signoutRedirect } = useAuth();

    useEffect(() => {
      signoutRedirect();
    }, [signoutRedirect]);

    return <p>{t('LoggingOut')}</p>;
};

export default LogoutPage;
